import {post} from "@/utils/request";
import apiCommonCategory from "@/api/common-category";

export default class apiBkBookFavor extends apiCommonCategory{
  static module = 'bk_book_favor'

  static async listDel(ids){
    return post('/home/bk_book_favor/listDel', {ids})
  }

}
